/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Tray_Embed_AllInputs */



/**
* | output |
* | --- |
* | "Embed All" |
*
* @param {Upload_Tray_Embed_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const upload_tray_embed_all = /** @type {((inputs?: Upload_Tray_Embed_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Tray_Embed_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle einbetten")
	return /** @type {LocalizedString} */ ("Embed All")
});